/*
 *  Project: dux - cancel input
 *  Description: Remove the text value by clicking on the appearing button.
 *  Author: bwin
 */

;(function ( $, window, document, undefined ){
    'use strict';

    var pluginName = 'dv_cancelinput',
        defaults = {};

    function Plugin( element, options ){

        this.element = element;
        this.$element = $( element );

        this.options = $.extend( {}, defaults, options );

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    $.extend( Plugin.prototype, {
        /*
        Initialize plugin
         */
        init: function (){

            this.$element.addClass( 'form-control-cancel' );
            this._wrapInput();
            this._addCancelBtn();
            this._registerEvents();
            this._checkInputVal();

        },

        /*
        Register events on elements to
        clear the input value
         */
        _registerEvents: function (){

            /*
            Show or hide cancel icon depending on the
            value length of the origin element
            Trigger custom event on cleared input
             */
            this.$element.on( 'keyup', function ( e ){

                var $this = $( e.delegateTarget ),
                    $cancelBtnIcon = $this.siblings( '.input-group-btn-cancel' ).find( '.dv' );

                $this.val().length > 0 ? $cancelBtnIcon.css( 'visibility', 'visible' ) : $cancelBtnIcon.css( 'visibility', '' ) && $this.trigger( 'cleared.dv.' + pluginName.replace('dv_', '') );
            } );

            /*
            Clear corresponding text input on click
            and trigger "keyup" to validate the current value
            */
            $( '.btn-cancel' ).off( 'click' ).on( 'click', function ( e ){
                e.preventDefault();

                var $cancelBtn = $( e.delegateTarget ),
                    $this = $cancelBtn.closest( '.input-group-cancel' ).children( '.form-control-cancel' );

                $this.val( '' );
                $this.focus();
                $this.trigger( 'keyup' );
            } );
        },

        /*
        Unique-ID setter for elements without ID
        */
        _setUniqueId: function ( id ){

            if ( !id ) {
                return Math.round( new Date().getTime() + (Math.random() * 100) );
            }
            return id;
        },

        /*
        Method to determine the size of the origin element (<input>).
        The size of the elements to be created depends on this.
         */
        _getElmSize: function (){

            // Which elements specify the size
            var $formGrp = $( this.$element.closest( '.form-group' ) ),
                $this = this.$element;

            if (
                $formGrp.hasClass( 'form-group-lg' ) ||
                $this.hasClass( 'input-lg' ) ) {

                return 'lg';
            }

            else if (
                $formGrp.hasClass( 'form-group-sm' ) ||
                $this.hasClass( 'input-sm' ) ) {

                return 'sm';
            }

            else {
                return false;
            }
        },

        /*
        Wrap the origin element into a parent (input-group)
        to control some behaviors by css styles.
         */
        _wrapInput: function (){
            var inputSize = this._getElmSize();

            this.$element.wrap( $( '<div class="input-group-cancel">' ) )
                .parent().addClass( inputSize ? 'input-group-cancel-' + inputSize : '' );
        },

        /*
        Add the cancel button as an input-group-btn
        to the custom input-group.
         */
        _addCancelBtn: function (){

            var inputSize = this._getElmSize(),

                $addCancelBtnGrp =
                    $( '<div class="input-group-btn-cancel">' ),

                $cancelBtn =
                    $( '<button type="button">' )
                        .addClass( 'btn-cancel' )
                        .attr( 'id', this.$element.attr( 'id' ) ? this.$element.attr( 'id' ) + '-btn-cancel' : 'btn-cancel-' + this._setUniqueId() )
                        .append( '<i class="dv dv-close dv-lg">' );

            $addCancelBtnGrp.insertAfter( this.$element );
            $cancelBtn.appendTo( $addCancelBtnGrp );
        },

        /*
        Check the initial input value to
        make the cancel button visible
         */
        _checkInputVal: function (){
            var $this = this.$element,
                $cancelBtnIcon = $this.siblings( '.input-group-btn-cancel' ).find( '.dv' );

            if ( $this.val().length > 0 ) {
                $cancelBtnIcon.css( 'visibility', 'visible' );
            }
        }
    } );

    $.fn[ pluginName ] = function ( options ){
        var args = arguments;


        if ( typeof options === 'string' && options.slice( 0, 1 ) === '#' ) {

            options = {
                color: options
            };

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );
        } else if ( options === undefined || typeof options === 'object' ) {

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );

        } else if ( typeof options === 'string' && options[ 0 ] !== '_' && options !== 'init' ) {

            var returns;

            this.each( function (){

                var instance = $.data( this, 'plugin_' + pluginName );

                if ( instance instanceof Plugin && typeof instance[ options ] === 'function' ) {
                    returns = instance[ options ].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                if ( options === 'destroy' ) {
                    $.data( this, 'plugin_' + pluginName, null );
                }

            } );

            return returns !== undefined ? returns : this;
        }
    };

})
( jQuery, window, document );

;(function ( $, window, document, undefined ){

    /*Select elements with certain css-class
    data-attributes help to style selector
    */
    $( function (){

        var $cancelInput = $( '.form-control-cancel' );

        $.each( $cancelInput, function (){

            var $this = $( this );

            $this.dv_cancelinput();
        } );
    } );
})( jQuery, window, document );
